(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
function initializeAnnouncementMarquee(){
 document.querySelectorAll('.mg-announcement').forEach(root=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const track=root.querySelector('.mg-announcement__track');
  const group=root.querySelector('[data-mg-original]');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  if(!reduced.matches){
   const duplicate=group.cloneNode(true);
   duplicate.removeAttribute('data-mg-original');
   duplicate.removeAttribute('id');
   duplicate.setAttribute('aria-hidden','true');
   duplicate.querySelectorAll('[id]').forEach(n=>n.removeAttribute('id'));
   duplicate.querySelectorAll('a,button,[tabindex]').forEach(n=>n.setAttribute('tabindex','-1'));
   track.append(duplicate);
  }
  const speed=()=>{const pixelsPerSecond=window.matchMedia('(max-width:749px)').matches?55:45;track.style.setProperty('--mg-marquee-duration',`${Math.max(8,group.getBoundingClientRect().width/pixelsPerSecond)}s`);};
  const observer=new ResizeObserver(speed);
  observer.observe(group);
  speed();
  root.mgCleanup=()=>observer.disconnect();
  root.querySelector('.mg-announcement__pause').addEventListener('click',event=>{const paused=root.dataset.paused!=='true';root.dataset.paused=String(paused);event.currentTarget.setAttribute('aria-pressed',String(paused));});
 });
}
initializeAnnouncementMarquee();
document.addEventListener('shopify:section:load',initializeAnnouncementMarquee);
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.mg-announcement').forEach(root=>root.mgCleanup?.()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-editorial-hero"] && !Shopify.designMode) return;
  try {
    
function setupEditorialHeroes(){
 document.querySelectorAll('.mg-hero').forEach(root=>{
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const track=root.querySelector('.mg-hero__track');
  const slides=[...root.querySelectorAll('.mg-hero__slide')];
  const dots=[...root.querySelectorAll('[data-mg-slide]')];
  const toggle=root.querySelector('[data-mg-toggle]');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  let timer,hovered=false,visible=true,paused=root.dataset.autoplay!=='true'||reduced.matches;
  const interval=Math.max(3000,Number(root.dataset.interval)||5000);
  const current=()=>Math.round(track.scrollLeft/track.clientWidth);
  const stop=()=>window.clearTimeout(timer);
  const update=()=>{if(!toggle)return;toggle.textContent=paused?'▶':'Ⅱ';toggle.setAttribute('aria-label',paused?toggle.dataset.play:toggle.dataset.pause);toggle.setAttribute('aria-pressed',String(paused));};
  const move=index=>track.scrollTo({left:((index+slides.length)%slides.length)*track.clientWidth,behavior:reduced.matches?'instant':'smooth'});
  const schedule=()=>{stop();if(paused||hovered||!visible||document.hidden||slides.length<2)return;timer=window.setTimeout(()=>{move(current()+1);schedule();},interval);};
  const manual=index=>{move(index);schedule();};
  root.querySelector('[data-mg-prev]')?.addEventListener('click',()=>manual(current()-1));
  root.querySelector('[data-mg-next]')?.addEventListener('click',()=>manual(current()+1));
  dots.forEach((dot,i)=>dot.addEventListener('click',()=>manual(i)));
  toggle?.addEventListener('click',()=>{paused=!paused;update();schedule();});
  root.addEventListener('mouseenter',()=>{hovered=true;stop();});
  root.addEventListener('mouseleave',()=>{hovered=false;schedule();});
  root.addEventListener('focusin',event=>{if(event.target===toggle)return;paused=true;update();stop();});
  root.addEventListener('pointerdown',stop,{passive:true});
  root.addEventListener('pointerup',schedule,{passive:true});
  track.addEventListener('scroll',()=>dots.forEach((dot,i)=>{if(i===current())dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');}),{passive:true});
  const visibility=()=>schedule();
  document.addEventListener('visibilitychange',visibility);
  const motion=()=>{if(reduced.matches){paused=true;update();}schedule();};
  reduced.addEventListener('change',motion);
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.2});
  observer.observe(root);
  root.mgCleanup=()=>{stop();observer.disconnect();document.removeEventListener('visibilitychange',visibility);reduced.removeEventListener('change',motion);};
  update();schedule();
 });
}
setupEditorialHeroes();
document.addEventListener('shopify:section:load',setupEditorialHeroes);
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.mg-hero').forEach(root=>root.mgCleanup?.()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-welcome-offer"]) return;
  try {
    
function initializeWelcomeOffer(){
 const dialog=document.querySelector('#MGWelcomeOffer');
 if(!dialog||dialog.dataset.ready)return;
 dialog.dataset.ready='true';
 const remember=()=>{try{sessionStorage.setItem('mg-welcome-seen','true');}catch{}};
 let timer;
 const open=()=>{clearTimeout(timer);if(!dialog.open){dialog.showModal();remember();}};
 document.addEventListener('click',event=>{
  const trigger=event.target.closest('a[href="#welcome10"],a[href$="#welcome10"]');
  if(trigger){event.preventDefault();open();}
 });
 dialog.querySelectorAll('[data-mg-welcome-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
 dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});
 let seen=false;
 try{seen=sessionStorage.getItem('mg-welcome-seen')==='true';}catch{}
 if(dialog.dataset.auto==='true'&&!seen){timer=setTimeout(()=>{if(document.hidden||[...document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"]')].some(element=>{const rect=element.getBoundingClientRect();const style=getComputedStyle(element);return rect.width>0&&rect.height>0&&style.visibility!=='hidden'&&style.display!=='none';}))return;open();},8000);}
 if(location.hash==='#welcome10')open();
}
initializeWelcomeOffer();
document.addEventListener('shopify:section:load',initializeWelcomeOffer);

  } catch(e) { console.error(e); }
})();
})();
